import { DatePicker } from "antd"
import { Link, useNavigate, useParams } from "react-router-dom"
import useApi from "../../core/customhook/useApi"
import dayjs, { Dayjs } from "dayjs"
import { useEffect, useState } from "react"
import Swal from "sweetalert2"
import { all_routes } from "../router/all_routes"
import { is_manager } from "../../environment"
import Loader from "../../core/common/selfLoder";
import CollapseHeader from "../../core/common/collapse-header/collapse-header"



interface FormData {
    ResignationDate: string
    RequestedRelievingDate: string
    RequestedRelievingDateAsPerPolicy: string
    NoticePeriodRequestDays: string
    NoticePeriodDifferenceDays: string | number
    Reasons: string
    Remarks: string
    Status: string
    employeeId: string
    emailId: string
    DOJ: string
    employeeName: string
    gender: string
    department: string
    designation: string
    location: string
    DOB: string
    EmployeeStatus: string
    offboardingDocuments: string[]
    Grade: string
}


const ViewResignation = () => {

    // const [isResignationDateProcessed, setIsResignationDateProcessed] = useState(false);
    const [formData, setFormData] = useState<FormData>({
        ResignationDate: "",
        RequestedRelievingDate: "",
        RequestedRelievingDateAsPerPolicy: "",
        NoticePeriodRequestDays: "",
        NoticePeriodDifferenceDays: "",
        Reasons: "",
        Remarks: "",
        Status: "",
        employeeId: "",
        emailId: "",
        DOJ: "",
        employeeName: "",
        gender: "",
        department: "",
        designation: "",
        location: "",
        DOB: "",
        EmployeeStatus: "",
        offboardingDocuments: [] as string[],
        Grade: ""
    });

    // const navigate = useNavigate();
    const { employeeId } = useParams<{ employeeId: string }>();


    const endpoint = !employeeId
        ? "/api/get-resignation"
        : "/api/manager/team-viewresignation"

    const options = !employeeId
        ? { method: "GET" as const, autoCall: true }
        : { method: "POST" as const, autoCall: true, payload: { employee_id: employeeId } }

    const { data: getResignationData, loading: resignationData, error } = useApi(
        endpoint,
        options
    );


    useEffect(() => {
        if (getResignationData?.data.resignation_date) {
            setFormData({
                ResignationDate: dayjs(getResignationData.data.resignation_date).format("DD-MM-YYYY"),
                RequestedRelievingDate: dayjs(getResignationData.data.requested_relieving_date).format("DD-MM-YYYY"),
                RequestedRelievingDateAsPerPolicy: dayjs(getResignationData.data.relieving_date_as_per_policy).format("DD-MM-YYYY"),
                NoticePeriodRequestDays: getResignationData?.data.notice_period_requested_days || "",
                Reasons: getResignationData?.data.reason || "",
                Remarks: getResignationData.data.remarks || "",
                Status: getResignationData.data.status || "",
                employeeId: getResignationData.data.employee_id || "",
                emailId: getResignationData.data.email_id || "",
                DOJ: getResignationData?.data.join_date || "",
                employeeName: getResignationData?.data.employee_name || "",
                department: getResignationData?.data.department || "",
                designation: getResignationData?.data.designation,
                location: getResignationData?.data.work_location || "",
                DOB: getResignationData?.data.date_of_birth || "",
                gender: "",
                EmployeeStatus: getResignationData?.data.employee_status || "",
                // NoticePeriodDifferenceDays: dayjs(formData.ResignationDate).diff(dayjs(formData.RequestedRelievingDate), 'day')
                NoticePeriodDifferenceDays: "",
                Grade: getResignationData?.data.band || "",
                offboardingDocuments: getResignationData?.data?.document_path
                    ? JSON.parse(getResignationData.data.document_path)
                    : [],
            });
        }
    }, [getResignationData?.data.resignation_date, employeeId]);



    useEffect(() => {
        if (!formData.ResignationDate || !formData.RequestedRelievingDate) return;
        // console.log(formData.RequestedRelievingDateAsPerPolicy, "AND", formData.ResignationDate)

        const resignation = dayjs(formData.ResignationDate, "DD-MM-YYYY");
        const relieving = dayjs(formData.RequestedRelievingDateAsPerPolicy, "DD-MM-YYYY");

        if (!resignation.isValid() || !relieving.isValid()) return;

        const diff = relieving.diff(resignation, "day").toString();

        setFormData(prev => {
            if (prev.NoticePeriodDifferenceDays === diff) return prev;

            return {
                ...prev,
                NoticePeriodDifferenceDays: diff,
            };
        });
    }, [formData.ResignationDate, formData.RequestedRelievingDate]);

    const { callApi: withdrawnApi } = useApi(
        `/api/resignation-withdrawn`, {
        method: "POST",
        autoCall: false
    })

    const handleWithdrawResignation = async () => {
        if (!formData.employeeId) {
            console.error("No employee ID found");
            return;
        }

        const result = await Swal.fire({
            title: "Are you sure?",
            text: "Do you want to withdraw Off Borading request ?",
            icon: "info",
            showCancelButton: true,
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
            confirmButtonText: "Yes, submit",
            cancelButtonText: "Cancel"
        });

        // If user cancels
        if (!result.isConfirmed) return;


        try {
            // Call the API to withdraw resignation
            const response = await withdrawnApi();

            if (response?.success && response?.statusCode === 200) {
                await Swal.fire({
                    title: "Application Accepted",
                    text: response.message || "Resignation withdrawn successfully",
                    icon: "success",
                });

                // Update local state AFTER alert
                setFormData(prev => ({
                    ...prev,
                    Status: "Withdrawn",
                }));
            } else {
                Swal.fire({
                    title: "Failed",
                    text: response?.message || "Failed to withdraw resignation",
                    icon: "error",
                });
            }
        } catch (error) {
            console.error("Error withdrawing resignation:", error);
            // alert("Something went wrong. Please try again.");
        }
    };


    return (
        <>
            <Loader loading={resignationData} />
            <div className="page-wrapper">
                <div className="content">

                    {/* Page Header */}
                    <div className="d-md-flex d-block align-items-center justify-content-between page-breadcrumb mb-3">
                        <div className="my-auto mb-2">
                            <h2 className="mb-1">Offboarding Application</h2>
                            <nav>
                                <ol className="breadcrumb mb-0">
                                    <li className="breadcrumb-item">
                                        <Link to="/">
                                            <i className="ti ti-smart-home" />
                                        </Link>
                                    </li>
                                    <li className="breadcrumb-item">Offboarding</li>
                                    <li className="breadcrumb-item active">
                                        Offboarding
                                    </li>
                                </ol>
                            </nav>
                        </div>
                        <div className="d-flex my-xl-auto right-content align-items-center flex-wrap ">
                            <div className="head-icons ms-2">
                                <CollapseHeader />
                            </div>
                        </div>
                    </div>

                    {/* Main Card */}
                    {getResignationData?.data.resignation_date
                        ? (<div className="card">
                            <form >
                                <div className="card-header w-full d-flex align-items-center justify-content-between mb-3">
                                    <h5 className="mb-0">Offboarding Request</h5>

                                    <div className="d-flex align-items-center gap-2">
                                        {is_manager && (
                                            <div className="d-flex align-items-center bg-primary text-white rounded-pill py-2 px-3">
                                                <span className="px-2 me-2 bg-light text-dark rounded-pill small fw-semibold">
                                                    STATUS
                                                </span>
                                                <span className="text-uppercase fw-semibold">
                                                    {formData.Status}
                                                </span>
                                            </div>
                                        )}
                                    </div>
                                </div>



                                <div className="row">
                                    <div className="row m-1">
                                        {/* Employee Details */}

                                        <div className="col-md-6">
                                            <div className="card h-100">
                                                <div className="card-header d-flex align-items-center justify-content-between">
                                                    <h5 className="mb-0">Employee Details</h5>
                                                </div>

                                                <div className="card-body">
                                                    <div className="row mb-3 align-items-center">
                                                        <label className="col-4 col-form-label text-end">Employee Name</label>
                                                        <div className="col-8">
                                                            <input
                                                                type="text"
                                                                className="form-control"
                                                                placeholder="Enter employee name"
                                                                value={formData.employeeName || ""}
                                                                readOnly
                                                            />
                                                        </div>
                                                    </div>

                                                    <div className="row mb-3 align-items-center">
                                                        <label className="col-4 col-form-label text-end">Employee ID</label>
                                                        <div className="col-8">
                                                            <input
                                                                type="text"
                                                                className="form-control"
                                                                placeholder="EMP001"
                                                                value={formData.employeeId || ""}
                                                                readOnly
                                                            />
                                                        </div>
                                                    </div>

                                                    <div className="row mb-3 align-items-center">
                                                        <label className="col-4 col-form-label text-end">Date of Birth</label>
                                                        <div className="col-8">
                                                            <input
                                                                className="form-control datetimepicker"
                                                                value={
                                                                    formData.DOB ? dayjs(formData.DOB, "DD-MM-YYYY").format("DD MMMM YYYY") : formData.DOB}
                                                                disabled
                                                                readOnly
                                                            />
                                                        </div>
                                                    </div>

                                                    <div className="row mb-3 align-items-center">
                                                        <label className="col-4 col-form-label text-end">Date of Joining</label>
                                                        <div className="col-8">
                                                            <input
                                                                className="form-control datetimepicker"
                                                                value={
                                                                    formData.DOJ ?
                                                                        dayjs(formData.DOJ, "DD-MM-YYYY").format("DD MMMM YYYY")
                                                                        : formData.DOJ}
                                                                readOnly
                                                                disabled
                                                            />
                                                        </div>
                                                    </div>

                                                    <div className="row mb-3 align-items-center">
                                                        <label className="col-4 col-form-label text-end">Department</label>
                                                        <div className="col-8">
                                                            <input
                                                                type="text"
                                                                className="form-control"
                                                                placeholder=""
                                                                value={formData.department || ""}
                                                                readOnly
                                                            />
                                                        </div>
                                                    </div>

                                                    <div className="row mb-3 align-items-center">
                                                        <label className="col-4 col-form-label text-end">Designation</label>
                                                        <div className="col-8">
                                                            <input
                                                                type="text"
                                                                className="form-control"
                                                                placeholder=""
                                                                value={formData.designation || ""}
                                                                readOnly
                                                            />
                                                        </div>
                                                    </div>
                                                    <div className="row mb-3 align-items-center">
                                                        <label className="col-4 col-form-label text-end">Work Location</label>
                                                        <div className="col-8">
                                                            <input
                                                                type="text"
                                                                className="form-control"
                                                                placeholder=""
                                                                value={formData.location || ""}
                                                                readOnly
                                                            />
                                                        </div>
                                                    </div>
                                                    <div className="row mb-3 align-items-center">
                                                        <label className="col-4 col-form-label text-end">Grade</label>
                                                        <div className="col-8">
                                                            <input
                                                                type="text"
                                                                className="form-control"
                                                                placeholder=""
                                                                value={formData.Grade || ""}
                                                                readOnly
                                                            />
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        {/* Resignation Details */}
                                        <div className="col-md-6">
                                            <div className="card h-100">
                                                <div className="card-header d-flex align-items-center justify-content-between">
                                                    <h5 className="mb-0">Offboarding Details</h5>
                                                </div>

                                                <div className="card-body">
                                                    {/* Resignation Date */}
                                                    <div className="row mb-3 align-items-center">
                                                        <label className="col-4 col-form-label text-end">Resignation Date</label>
                                                        <div className="col-8">
                                                            {/* {isClient && ( */}
                                                            <input
                                                                className="form-control datetimepicker"
                                                                value={
                                                                    formData.ResignationDate
                                                                        ? dayjs(formData.ResignationDate, "DD-MM-YYYY").format("DD MMMM YYYY")
                                                                        : formData.ResignationDate
                                                                }
                                                                placeholder="DD-MM-YYYY"
                                                                disabled
                                                                required
                                                            />
                                                            {/* )} */}
                                                        </div>
                                                    </div>

                                                    {/* Relieving Date Requested */}
                                                    <div className="row mb-3 align-items-center">
                                                        <label className="col-4 col-form-label text-end">Relieving Date Requested</label>
                                                        <div className="col-8">
                                                            <input
                                                                className="form-control datetimepicker"
                                                                value={
                                                                    formData.RequestedRelievingDate
                                                                        ? dayjs(formData.RequestedRelievingDate, "DD-MM-YYYY").format("DD MMMM YYYY")
                                                                        : formData.RequestedRelievingDate
                                                                }
                                                                disabled
                                                                required
                                                            />
                                                        </div>
                                                    </div>

                                                    {/* Notice Period Requested */}
                                                    <div className="row mb-3 align-items-center">
                                                        <label className="col-4 col-form-label text-end">Notice Period Requested</label>
                                                        <div className="col-8">
                                                            <input
                                                                className="form-control"
                                                                min={0}
                                                                value={formData?.NoticePeriodRequestDays}
                                                                placeholder="Enter number of days"
                                                                readOnly
                                                            />
                                                        </div>
                                                    </div>

                                                    {/* Notice Period Difference Days */}
                                                    <div className="row mb-3 align-items-center">
                                                        <label className="col-4 col-form-label text-end">Notice Period Difference Days</label>
                                                        <div className="col-8">
                                                            <input type="text"
                                                                className="form-control"
                                                                value={formData?.NoticePeriodDifferenceDays || ""}
                                                                readOnly
                                                            // disabled={isViewOnly} 
                                                            />
                                                        </div>
                                                    </div>

                                                    {/* Relieving Date As Per Policy */}
                                                    <div className="row mb-3 align-items-center">
                                                        <label className="col-4 col-form-label text-end">Relieving Date As Per Policy</label>
                                                        <div className="col-8">
                                                            <input
                                                                className="form-control datetimepicker"
                                                                value={
                                                                    formData.RequestedRelievingDateAsPerPolicy
                                                                        ? dayjs(formData.RequestedRelievingDateAsPerPolicy, "DD-MM-YYYY").format("DD MMMM YYYY")
                                                                        : formData.RequestedRelievingDateAsPerPolicy
                                                                }
                                                                disabled
                                                            />
                                                        </div>
                                                    </div>

                                                    {/* Reasons */}
                                                    <div className="row mb-3 align-items-start">
                                                        <label className="col-4 col-form-label text-end">Reasons</label>
                                                        <div className="col-8">
                                                            <input
                                                                className="form-control"
                                                                value={formData.Reasons ?? ""}
                                                                readOnly
                                                            >
                                                            </input>
                                                        </div>
                                                    </div>
                                                    <div className="row mb-3 align-items-start">
                                                        <label className="col-4 col-form-label text-end">Remarks</label>
                                                        <div className="col-8">
                                                            <textarea
                                                                className="form-control"
                                                                placeholder="Enter remarks"
                                                                value={formData.Remarks ?? ""}
                                                                disabled
                                                            >
                                                            </textarea>
                                                        </div>
                                                    </div>

                                                    {/* Upload Documents */}
                                                    <div className="row mb-3 align-items-start">
                                                        <label className="col-4 col-form-label text-end">View Documents</label>
                                                        <div className="col-8">
                                                            {formData.offboardingDocuments && formData.offboardingDocuments.length > 0 ? (
                                                                <div className="d-flex flex-column gap-2">
                                                                    {formData.offboardingDocuments.map((doc: string, index: number) => (
                                                                        <button
                                                                            key={index}
                                                                            type="button"
                                                                            className="btn btn-outline-primary"
                                                                            onClick={() => window.open(doc, "_blank")}
                                                                        >
                                                                            View Document {index + 1}
                                                                        </button>
                                                                    ))}
                                                                </div>
                                                            ) : (
                                                                <span className="form-control text-muted text-center">No Documents</span>
                                                            )}
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                    </div>

                                </div>
                            </form>
                            <div className="d-flex justify-content-end p-2">
                                {is_manager && formData.Status?.toLowerCase() === "pending" && (
                                    <button
                                        type="button"
                                        onClick={handleWithdrawResignation}
                                        className="btn btn-primary"// optional: fixed width
                                    >
                                        Withdraw Application
                                    </button>
                                )}
                            </div>
                        </div>)
                        : (<div
                            className="card d-flex justify-content-center align-items-center text-center"
                            style={{ minHeight: "250px" }}
                        >
                            <h6 className="text-muted">No Data Available</h6>
                        </div>)
                    }
                </div >

                {/* Footer */}
                < div className="footer d-flex align-items-center justify-content-center bg-white border-top p-3" >
                    <p className="mb-0"> © {new Date().getFullYear()} WeConnect. All rights reserved.</p>
                </div >
            </div >
        </>
    )
}

export default ViewResignation






// <div className="card-header w-full d-flex align-items-center justify-content-between mb-3">
//                                     {/* Left: Heading */}
//                                     <h5 className="mb-0">Offboarding Request</h5>
//                                     {is_manager ?
//                                         (<div className="d-flex align-items-center bg-primary rounded-pill py-2 px-2">
//                                             <label
//                                                 className="px-2 me-2 bg-light rounded-pill"
//                                                 style={{
//                                                     backgroundColor: "white",
//                                                     color: "black",
//                                                 }}>
//                                                 STATUS
//                                             </label>
//                                             <label className="mb-0 text-uppercase">{formData.Status || ""}</label>
//                                         </div>) : (<></>)}
//                                 </div>